export default __webpack_public_path__ + "static/media/gallery-wip-pommel_08.db8ff7d1.jpg";